<template>
  <v-app>
    <upload-document-l
      :storeName="storeName"
      :bankImage="bankImage"
      :formStoreBank="formStoreBank"
      :formBizImage="formBizImage"
      :thaiBankList="thaiBankList"
      :isSubmiting="isSubmiting"
      @submit="submitForm(formStoreBank, formBizImage)"
      v-if="isVerifying == false"
      @openSnackbar="
        snackbarDialog = true;
        snackbarText = $event.text;
        snackbarToTop = $event.is_top;
      "
      :e1="e1"
    ></upload-document-l>
    <upload-document-s
      :e1="e1"
      @openSnackbar="
        snackbarDialog = true;
        snackbarText = $event.text;
        snackbarToTop = $event.is_top;
      "
      :storeName="storeName"
      :formStoreBank="formStoreBank"
      :formBizImage="formBizImage"
      :thaiBankList="thaiBankList"
      :isSubmiting="isSubmiting"
      @submit="submitForm(formStoreBank, formBizImage)"
      v-if="isVerifying == false"
    ></upload-document-s>
    <v-snackbar
      :top="snackbarToTop"
      v-model="snackbarDialog"
      style="display: flex; justify-content: center"
    >
      <span class="d-flex align-center"
        ><v-icon :style="{ color: 'red' }" class="pr-2">close</v-icon>
        {{ snackbarText }}</span
      >
      <v-btn color="#fddb00" flat @click="snackbarDialog = false">
        {{ $i18n.locale == "en" ? "Close" : "ปิด" }}
      </v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import UploadDocumentL from "@/components/front-web/UploadDocument/UploadDocumentL.vue";
import UploadDocumentS from "@/components/front-web/UploadDocument/UploadDocumentS.vue";
import { mapState } from "vuex";
import CryptoJS from "crypto-js";
export default {
  data() {
    return {
      e1: 1,
      snackbarToTop: false,
      snackbarDialog: false,
      snackbarText: "",
      isVerifying: true,
      formStoreBank: {
        store_bank_store_id: null,
        store_bank_account_name: "",
        store_bank_account_number: "",
        store_bank_bank_id: 1,
        store_bank_image: null,
        store_bank_type: 2,
      },
      formBizImage: {
        store_business_images: [],
      },
      storeProvince: "",
      isSubmiting: false,
      storeID: null,
      bankImage: null,
      storeName: {},
    };
  },
  components: {
    "upload-document-l": UploadDocumentL,
    "upload-document-s": UploadDocumentS,
  },
  async created() {
    if (
      this.$route.query.lang &&
      (this.$route.query.lang == "en" || this.$route.query.lang == "th")
    ) {
      this.$i18n.locale = this.$route.query.lang;
    }

    if (this.$route.query.cer) {
      let decypt = this.$route.query.cer
        .toString()
        .replace(/p1L2u3S/g, "+")
        .replace(/s1L2a3S4h/g, "/")
        .replace(/e1Q2u3A4l/g, "=");
      try {
        let CryptoText = CryptoJS.AES.decrypt(decypt, "s9d333dkj1594ro");
        let payloadData = JSON.parse(CryptoText.toString(CryptoJS.enc.Utf8));
        let form = {
          store_id: payloadData.store_id,
          province: payloadData.province,
        };
        let result = await this.$store.dispatch(
          "fetchStoreApproveBack/verifyHashedUrl",
          form
        );
        if (result === false) {
          location.replace("https://weserve.co.th");
        } else {
          if ("msg" in result && result.msg === false) {
            location.replace("https://weserve.co.th");
          }
          this.formStoreBank.store_bank_store_id = payloadData.store_id;
          this.storeID = payloadData.store_id;
          this.storeName = result.data;
          this.storeProvince = payloadData.province;
          await this.$store.dispatch("fetchDefaultRider/getThaiBank");
        }
        this.isVerifying = false;
      } catch {
        location.replace("https://weserve.co.th");
      }
    } else {
      location.replace("https://weserve.co.th");
    }
  },
  computed: {
    ...mapState({
      thaiBankList: (state) => state.fetchDefaultRider.thai_bank,
    }),
  },
  methods: {
    async submitForm(dataStoreBank, dataBizImage) {
      this.isSubmiting = true;
      let result = await this.createStoreBank(dataStoreBank);
      let result2 = await this.uploadBizImage(dataBizImage);
      this.isSubmiting = false;
      if (result === true && result2 === true) {
        // alert(
        //   this.$i18n.locale == "th"
        //     ? "ส่งเอกสาร"
        //     : "Sent document successfully!!"
        // );
        this.e1 = 2;
      } else {
        alert("Something went wrong !!");
      }
    },
    async uploadBizImage(dataBizImage) {
      let form = JSON.parse(JSON.stringify(dataBizImage));
      for (let val of form.store_business_images) {
        delete val.name;
        delete val.desc;
      }
      let result = await this.$store.dispatch(
        "fetchStoreApproveBack/uploadBizImage",
        {
          form,
          province: this.storeProvince,
          store_id: this.storeID,
        }
      );
      return result;
    },
    async createStoreBank(dataStoreBank) {
      let form = JSON.parse(JSON.stringify(dataStoreBank));
      if (form.store_bank_image === null) {
        delete form.store_bank_image;
      }
      let result = await this.$store.dispatch(
        "fetchStoreApproveBack/createStoreBank",
        {
          form,
          province: this.storeProvince,
        }
      );
      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>